import { Service } from './../../servicos/service.model';
import { ClubsService } from './../../clubs/clubs.service';
import { Partner } from './../../partiners/partner.model';
import { AuthService } from './../../../shared/services/auth.service';
import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Partnership } from '../partnership.model';
import { PartnershipService } from '../partnership.service';
import { Club } from '../../clubs/club.model';
import { PartnersService } from '../../partiners/partiners.service';

@Component({
    selector: 'ng-partnership-form',
    templateUrl: 'partnership-form.component.html'
})

export class PartnershipFormComponent extends BaseFormComponent<Partnership> {
  
    public partners:Partner[];
    public clubs: Club[];
    public services: Service[];

    constructor(
        protected injector: Injector, 
        protected partnershipServ: PartnershipService,
        protected partnerServ: PartnersService,
        protected clubServ: ClubsService
    ) {
        super(injector, 'partnership', '/admin/partnership', Partnership.fromJsonToObject, partnershipServ);
    }

    protected buildForm(): void {
        this.objectForm = this.formBuilder.group({
            clubs_id:this.formBuilder.control(null,[Validators.required]),
            partners_id:this.formBuilder.control(null),
            services_id:this.formBuilder.control(null,[Validators.required]),
            users_id:this.formBuilder.control(this.auth.user.id),
            destription:this.formBuilder.control(null),
            id: this.formBuilder.control(null),
        })
    }

    protected initChildProprieties(): void {
        this.partners=new Array<Partner>();
        this.clubs=new Array<Club>();
        this.services=new Array<Service>();
    }

    protected initChildMethods(): void { 
        this.formSubscription.add(this.partnerServ.getAll().subscribe(partners=>{
            this.partners=partners
            this.setServicesOfPartner(this.object.partners_id)
        }))
        this.formSubscription.add(this.clubServ.getAll().subscribe(clubs=>this.clubs=clubs))
    }

    setServicesOfPartner(id:number){
        this.services=this.partners.find(partner=>partner.id==id).services
    }
    
}